export default __webpack_public_path__ + "static/media/ai.aa60586b.png";